import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const AlertError = (props: SvgIconProps) => (
  <SvgIcon
    {...props}
    viewBox="0 0 32 30"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 32, height: 30, fill: 'none', ...props.sx }}
    data-testid="alertErrorIcon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.064 1.53081C14.8627 -0.0666977 17.1424 -0.0666956 17.9412 1.53082L31.7738 26.5293C32.4943 27.9704 31.4464 29.666 29.8351 29.666L2.17002 29.666C0.558783 29.666 -0.48917 27.9704 0.2314 26.5293L14.064 1.53081ZM15.9996 24.866C16.9364 24.866 17.6958 24.1066 17.6958 23.1699C17.6958 22.2331 16.9364 21.4737 15.9996 21.4737C15.0629 21.4737 14.3035 22.2331 14.3035 23.1699C14.3035 24.1066 15.0629 24.866 15.9996 24.866ZM14.3035 12.1622C14.3035 12.795 14.309 18.8429 15.9996 18.8429C17.6903 18.8429 17.6958 12.795 17.6958 12.1622C17.6958 11.2254 16.9364 10.466 15.9996 10.466C15.0629 10.466 14.3035 11.2254 14.3035 12.1622Z"
      fill="#D52B1E"
    />
  </SvgIcon>
);

export default AlertError;
